import type { Role } from './session';

/**
 * Which role the interface is currently previewing, if any.
 *
 * Kept in localStorage rather than React state so a full page reload does not
 * silently snap the owner back to their real view mid-inspection — the point of
 * the feature is to see the other side properly, including on refresh.
 *
 * This is a REQUEST, not a grant. The server compares it against the session's
 * real role and only ever downgrades, so writing "owner" here achieves nothing.
 */
const KEY = 'greengrocer:view-as';

export function getViewAs(): Role | null {
  const stored = localStorage.getItem(KEY);
  return stored === 'admin' || stored === 'user' ? stored : null;
}

export function setViewAs(role: Role | null): void {
  if (role === null) localStorage.removeItem(KEY);
  else localStorage.setItem(KEY, role);
  // A hard reload is deliberate: every cached query was fetched under the old
  // role and would otherwise show stale, over-privileged data in the new view.
  window.location.reload();
}
